import React, { FC, useEffect, useState } from "react";
import { useStoreDispatch, useStoreSelector } from "../../../../../hooks/StoreHooks";
import { useNavigate, useParams } from "react-router-dom";
import { useDialogs } from "../../../../providers/dialogs_provider";
import { getCurrentCustomer, getCurrentUser } from "../../../../core/common_functions";
import { useDoorConfigurationBuilderActions } from "../../../../../store/reducers/door_configuration_builder";
import { DoorConfigurationConditions } from "../../../../models/door_configuration";
import { useConfigurationsService } from "../../../../services/configurations_service";
import Loading from "../../../../../components/Loading/loading";
import { Autocomplete, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, styled, TextField } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { FormikErrors, FormikProps, useFormik } from "formik";
import { NullableString } from "../../../../core/common_types";
import { RegionsApi } from "../../../../api/regions_api";
import { Province } from "../../../../models/regions_models";
import { City } from "../../../../models/regions_models";
import { log } from "console";
import { string } from "yup";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import { AllegatiUploader } from "../../../../../components/Preventivo/allegati_component";
import ConditionsForm from "../../../../../components/Formik/ConditionForm";
import { CategoryCode } from "../../../../models/category";
import { useConfigurationsServicePergola } from "../../../../services/pergola_service";
import { usePergolaConfigurationBuilderActions } from "../../../../../store/reducers/pergola_configuration_builder";

export const ConditionsPage = () => {
  const { base, pergolaConfigurationBuilder } = useStoreSelector(store => store);
  const navigate = useNavigate();
  const { id } = useParams();
  const dialogs = useDialogs();
  const [refresh, setRefresh] = useState<boolean>(false);
  const dispatcher = useStoreDispatch();
  const [isSubmit, setSubmit] = useState<boolean>(false);
  const currentUser = getCurrentUser(base);
  const pergolaService = useConfigurationsServicePergola();
  const { setStepActive, setStepComplete } = usePergolaConfigurationBuilderActions();
  const applyDiscount = async (
    values: DoorConfigurationConditions,
    formik: FormikProps<DoorConfigurationConditions>
  ) => {
    try {
      setRefresh(true);
      if (!pergolaConfigurationBuilder.configuration) throw "invalid configuration";

      const conditions = await pergolaService.aggiornaCondizioni(
          currentUser,
          pergolaConfigurationBuilder.configuration?.configurationId,
          values
      );

      console.log("Aggiornamento", conditions);
      formik.setValues(conditions);
      setRefresh(false);
    } catch (e: any) {
      setRefresh(false);

      if (typeof e == "string") {
        dialogs?.showError("Attenzione...", e);
      } else {
        if (e.severity == "error") {
          dialogs?.showError("Attenzione...", e.message);
        } else if (e.severity == "warning") {
          dialogs?.showWarning("Attenzione...", e.message);
        }
      }
    } 
  };
  const checkBeforeSave = (formik: FormikProps<DoorConfigurationConditions>) => {
    if (!currentUser.isCustomer && !formik.values.isServiceCustomer) return null;

    let errors: FormikErrors<DoorConfigurationConditions> = {      
      customClientName: !formik.values.customClientName ? "Campo obbligatorio" : "",
      customClientCity: !formik.values.customClientCity ? "Campo obbligatorio" : "",
      customClientProvince: !formik.values.customClientProvince ? "Campo obbligatorio" : "",
    };

    formik.setErrors(errors);

    let res = Object.entries(errors).filter(values => values[1]);
    return res.length > 0 ? Object.fromEntries(res) : null;
  }
  const submit = async (values: DoorConfigurationConditions,formik: FormikProps<DoorConfigurationConditions>) => {
    try {
      let errors = checkBeforeSave(formik);
      if (errors) return;

      if (!pergolaConfigurationBuilder.configuration) throw "invalid configuration";

      setSubmit(true);

      await pergolaService.setCondizioni(currentUser, pergolaConfigurationBuilder.configuration.configurationId, values);
      dispatcher(setStepComplete({ stepSlug: "condizioni", isComplete: true }));

      navigate(`/pergola-configurations/${id}/preventivo`);
    } catch (e: any) {
      setSubmit(false);

      if (typeof e == "string") {
        dialogs?.showError("Attenzione...", e);
      } else {
        if (e.severity == "error") {
          dialogs?.showError("Attenzione...", e.message);
        } else if (e.severity == "warning") {
          dialogs?.showWarning("Attenzione...", e.message);
        }
      }
    }
  }
  return (
    <>  
      {pergolaConfigurationBuilder.configuration && (
          <ConditionsForm
              currentUser={currentUser}
              quote_id = {pergolaConfigurationBuilder.configuration.configurationId}
              applyDiscount={applyDiscount}
              category = {CategoryCode.Pergola}
              handlingSubmit={submit}
              goBack={`/pergola-configurations/${pergolaConfigurationBuilder.configuration?.configurationId}/accessori-vari`}
          />
      )}
    </>
  );
}